// Wires the inline head loader to the build-time container id and replays the
// anonymous consent saved on a previous visit BEFORE gtm.js starts, so the
// container boots with an up-to-date consent state (mirrors the website's
// `window.__consentReady` handshake). Server-side user preferences arrive
// later through AnalyticsService.applyConsents — Consent Mode v2 advanced
// tolerates updates after load.
import { GTM_ID } from '../../config/env';
import { readAnonymousConsent } from './anonymous-consent';

export function installGtm(): void {
  if (!GTM_ID || typeof window === 'undefined') {
    return;
  }

  window.__GTM_ID = GTM_ID;

  const anon = readAnonymousConsent();
  if (anon && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: anon.analytics ? 'granted' : 'denied',
      ad_storage: anon.marketing ? 'granted' : 'denied',
      ad_user_data: anon.marketing ? 'granted' : 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
    });
  }
  window.__consentApplied = true;
  window.__loadGtmWhenReady?.();
}
